import { Grid } from '@mui/material';
import Button from '../../../../components/button/button.component';
import { useContext, useEffect } from 'react';
import { CancelContext } from '../../../../contexts/cancellation.context';
import { setCookie } from '../../../../utils/generaFunctions';
import shopImg from '../../../../imgs/shop_logo2.png';

const Paused = () => {
    const {userInfo, cancelInfo, setLoading} = useContext(CancelContext);
    useEffect(()=>{
        setLoading(false);
        setCookie("cancellation-"+userInfo.email,"yes", 1/12);
    })
    return (
        <Grid container className='confirmed-container'>
            <Grid container className='flex-vertical'>
                <Grid item className='title'>
                    <h1>OK! We hit the PAUSE<br/>button for you</h1>
                </Grid>
                <Grid item className='block-header-black'>
                Your next payment date will be on {cancelInfo.renew_date}
                </Grid>
                <Grid item className='body-roman' >
                    You can reactivate earlier at any time by reach out to us at <a className='body-black' href="mailto:support+cancel@misstomrsbox.com">support@misstomrsbox.com</a>
                </Grid>
                <div className='line'></div>
                <Grid item className='body-roman' >
                    Don't miss out on our SHOP's amazing à la carte selection. #TreatYourself
                    <img className='shop_image' alt={`img-shop`} src={shopImg} style={{display:shopImg?"":"none"}}></img>
                </Grid>
                <a className={`button-link`} href={"https://shop.misstomrsbox.com/"}><Button text="Shop Now"></Button></a>
            </Grid>
        </Grid>
    )
}

export default Paused;